import Vue from 'vue'
import Vuex from 'vuex'
import company from './modules/company'
import language from './modules/language'
import message from './modules/message'
import user from './modules/user'
import ui from './modules/ui'
import mobileapp from './modules/mobileapp'
import orders from './modules/orders'
import followup from './modules/followup'
import reminder from './modules/reminder'
import permission from './modules/permission'
import subscriptions from './modules/subscriptions'
import constants from './modules/constants'
import tours from './modules/tours'
import currency from './modules/currency'
import riders from './modules/riders'
import customers from './modules/customers'
import donation from './modules/donation'
import clinic from './modules/clinic'
import hq from './modules/hq'
import review from './modules/review'
import insight from './modules/insight'
import marketing from './modules/marketing'
import treatment from './modules/treatment'
import reservationPreorder from './modules/reservationPreorder'
import address from './modules/address'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user, company, language, message, ui, mobileapp, orders, followup, reminder, permission, subscriptions,
    constants, tours, currency, riders, customers, donation, clinic, review, insight, marketing, treatment, reservationPreorder, hq, address
  },
  plugins: [createPersistedState({ key: 'pc', paths: ['user'] })]
})

window.$store = store

export default store
